import ApiService from './ApiService'

class ClassService {

  postClickerForClass = async (apiToken, classId, clickerType, requestId) => {
    var url = `/api/class/${classId}/clicker/${clickerType}`
    var params = { requestId }
    var response = null
    try {
      response = await ApiService.post(apiToken, url, params)
    } catch (err) {
      console.error(err)
    }
    return response
  }


}
export default new ClassService()
